import {
  Button,
  Empty,
  Popconfirm,
  Spin,
  Tag,
  message
} from "antd";

import {
  MobileOutlined
} from "@ant-design/icons";

import {
  useEffect,
  useState
} from "react";

import AccountShell
  from "./accountShell";

import {
  getAccountDevices,
  revokeAccountDevice
} from "../../api/account";

export default function Devices() {
  const [data, setData] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  const load = async () => {
    try {
      setLoading(true);

      const res =
        await getAccountDevices();

      setData(
        res?.data?.data || []
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const revoke = async uuid => {
    try {
      await revokeAccountDevice(
        uuid
      );

      message.success(
        "Đã thu hồi thiết bị."
      );

      await load();
    } catch (e) {
      message.error(
        "Không thể thu hồi thiết bị."
      );
    }
  };

  return (
    <AccountShell
      title="Thiết bị đăng nhập"
      description="Quản lý thiết bị Books OS đã đăng ký"
    >
      <div
        className="
          bg-amber-50
          border
          border-amber-100
          rounded-2xl
          p-4
          text-[12px]
          leading-5
          text-amber-800
          mb-5
        "
      >
        Danh sách hiện tại là các thiết bị
        Books OS đã đăng ký với tài khoản.
        Website chưa lưu lịch sử đăng nhập
        web theo từng thiết bị.
      </div>

      <Spin spinning={loading}>
        {data.length ? (
          <div className="space-y-3">
            {data.map(item => {
              const revoked =
                Number(
                  item.revoked
                ) === 1;

              return (
                <div
                  key={item.device_uuid}
                  className="
                    border
                    border-slate-100
                    rounded-2xl
                    p-4
                    flex
                    gap-4
                    items-center
                  "
                >
                  <span
                    className="
                      w-12 h-12
                      rounded-xl
                      bg-blue-50
                      text-blue-600
                      flex
                      items-center
                      justify-center
                      text-xl
                      shrink-0
                    "
                  >
                    <MobileOutlined />
                  </span>

                  <div
                    className="
                      flex-1
                      min-w-0
                    "
                  >
                    <p
                      className="
                        font-bold
                        text-slate-900
                        m-0
                      "
                    >
                      {item.device_name ||
                        "Books OS"}
                    </p>

                    <p
                      className="
                        text-[11px]
                        text-slate-400
                        break-all
                        mt-1
                        mb-2
                      "
                    >
                      {item.device_uuid}
                    </p>

                    <Tag
                      color={
                        revoked
                          ? "default"
                          : "green"
                      }
                    >
                      {revoked
                        ? "Đã thu hồi"
                        : "Đang hoạt động"}
                    </Tag>
                  </div>

                  {!revoked && (
                    <Popconfirm
                      title="Thu hồi thiết bị?"
                      description="Thiết bị phải đăng ký lại để tiếp tục xin quyền đọc sách."
                      okText="Thu hồi"
                      cancelText="Hủy"
                      onConfirm={() =>
                        revoke(
                          item.device_uuid
                        )
                      }
                    >
                      <Button danger>
                        Thu hồi
                      </Button>
                    </Popconfirm>
                  )}
                </div>
              );
            })}
          </div>
        ) : (
          <Empty
            description="Chưa có thiết bị Books OS"
          />
        )}
      </Spin>
    </AccountShell>
  );
}
